import { ArrowRight, Users, Sparkles, TrendingUp, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { careersCulture } from "@/assets/images";

const CULTURE_IMG = careersCulture;

const PERKS = [
  { icon: Users, t: "People first", d: "Small, empowered teams with zero politics." },
  { icon: Sparkles, t: "Deep work", d: "Focus time, great equipment, and async-first culture." },
  { icon: TrendingUp, t: "Ownership", d: "Meaningful ESOP for every full-time hire." },
];

const Careers = () => {
  return (
    <div data-testid="page-careers">
      <section className="border-b border-slate-200 bg-slate-50">
        <div className="container-section grid items-center gap-12 py-16 md:py-24 lg:grid-cols-2">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#0046B5]">Careers</span>
            <h1 className="mt-3 text-4xl font-bold leading-tight tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
              Build the future of <span className="brand-gradient-text">creative workflows</span>.
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600 md:text-lg">
              We're a young product company building tools thousands of creative professionals will use every day. If that sounds like your kind of problem, we'd love to hear from you.
            </p>
            <div className="mt-8">
              <Button asChild data-testid="careers-cta-join" className="rounded-md bg-[#0046B5] text-white hover:bg-[#003A99]">
                <a href="#join">Write to us <ArrowRight className="ml-2 h-4 w-4" /></a>
              </Button>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-slate-200 shadow-sm">
            <img src={CULTURE_IMG} alt="Ortelly culture" className="h-full w-full object-cover" />
          </div>
        </div>
      </section>

      {/* Culture */}
      <section className="container-section py-16 md:py-24">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#0046B5]">Culture</span>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">A place where great work is the norm.</h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            We believe the best products come from small, focused teams that care about the craft. We operate async-first, hire for strong taste, and trust every teammate with real ownership from day one.
          </p>
        </div>
        <div className="mt-12 grid gap-6 sm:grid-cols-3">
          {PERKS.map((p) => (
            <div key={p.t} className="rounded-md border border-slate-200 bg-white p-6 shadow-sm">
              <div className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-[#0046B5]/10 text-[#0046B5]">
                <p.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-slate-900">{p.t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{p.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Hiring soon */}
      <section id="join" className="border-t border-slate-200 bg-slate-50">
        <div className="container-section py-16 md:py-24">
          <div className="mx-auto max-w-3xl rounded-md border border-slate-200 bg-white p-8 text-center shadow-sm md:p-12">
            <div className="mx-auto inline-flex h-12 w-12 items-center justify-center rounded-md brand-gradient text-white">
              <Mail className="h-5 w-5" />
            </div>
            <h2 className="mt-6 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
              We're gearing up to hire.
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-600">
              Specific roles will open shortly. In the meantime, if you're an engineer, designer, or operator who cares deeply about craft and wants to shape Ortelly's early journey — write to us.
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <Button asChild data-testid="careers-email-btn" className="rounded-md bg-[#0046B5] text-white hover:bg-[#003A99]">
                <a href="mailto:sales@ortelly.com?subject=Introducing%20myself%20to%20Ortelly">Email us at sales@ortelly.com</a>
              </Button>
              <Button asChild variant="outline" data-testid="careers-contact-btn" className="rounded-md border-slate-200 hover:text-[#0046B5]">
                <Link to="/contact">Use the contact form</Link>
              </Button>
            </div>
            <p className="mt-6 text-xs text-slate-500">
              Tell us about a project you're proud of, and the kind of work you'd love to do next.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
